const SectionHeaderAlt = ({ section_heading, section_paragraph, classes }) => {
  return (
    <div className={`tw-mx-auto tw-mb-[3.5rem] tw-flex tw-max-w-[36.25rem] tw-flex-col tw-gap-12 tw-text-center  ${classes}`}>
      <h2 className="tw-text-40 tw-font-extrabold tw-text-[#00aaf5] tablet:tw-text-[3.5rem]">{section_heading}</h2>
      {section_paragraph && <p className="tw-mt-2">{section_paragraph}</p>}
    </div>
  );
};

export default SectionHeaderAlt;
